import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../app/store";
import {
  setStreetAddress,
  setCity,
  setPostalCode,
  setStateRegion,
  setPhoneNumber,
  setCountryCode,
  setFirstName,
  setLastName,
} from "../../reducer/registrationReducer";
import { setContactInformationModal } from "../../reducer/modalReducer";
import PhoneNumberInput from "../common/PhoneNumberInput";
import { setFieldCompleted } from "../../reducer/contacInformationReducer";

function ContactInformationModal() {
  const dispatch = useDispatch();
  const {
    streetAddress,
    city,
    postalCode,
    stateRegion,
    phoneNumber,
    countryCode,
    firstName,
    lastName,
  } = useSelector((state: RootState) => state.registration);
  const { contactInformationModal } = useSelector(
    (state: RootState) => state.modal
  );

  const profile = useSelector((state: RootState) => state.profile.profile);

  const [editedStreetAddress, setEditedStreetAddress] =
    useState<string>(streetAddress);
  const [editedCity, setEditedCity] = useState<any>(city);
  const [editedPostalCode, setEditedPostalCode] = useState<string>(postalCode);
  const [editedStateRegion, setEditedStateRegion] =
    useState<string>(stateRegion);
  const [editedPhoneNumber, setEditedPhoneNumber] =
    useState<string>(phoneNumber);
  const [editedCountryCode, setEditedCountryCode] =
    useState<string>(countryCode);
  const [editedFirstName, setEditedFirstName] = useState<string>(firstName);
  const [editedLastName, setEditedLastName] = useState<string>(lastName);

  // Validation error states
  const [errors, setErrors] = useState({
    streetAddress: "",
    city: "",
    postalCode: "",
    stateRegion: "",
    phoneNumber: "",
    firstName: "",
    lastName: "",
  });

  console.log("editedphon", editedPhoneNumber);
  const validateFields = () => {
    const newErrors = {
      streetAddress: editedStreetAddress ? "" : "Street address is required.",
      city: editedCity ? "" : "City is required.",
      postalCode:
        editedPostalCode.trim() === "" || editedPostalCode.trim().length >= 4
          ? ""
          : "Postal code must be at least 4 characters.",

      stateRegion: editedStateRegion ? "" : "State/Region is required.",
      phoneNumber:
        !editedPhoneNumber || editedPhoneNumber === "234-"
          ? "phone number is required."
          : "",
      firstName: editedFirstName ? "" : "First name is required.",
      lastName: editedLastName ? "" : "Last name is required.",
    };
    setErrors(newErrors);
    // Check if there are any errors

    return Object.values(newErrors).every((error) => error === "");
  };

  useEffect(() => {
    if (profile) {
      setEditedStreetAddress(profile.mainAddress || streetAddress);
      setEditedCity(profile.locations[0] || city);
      setEditedPostalCode(profile.locations[1] || postalCode);
      setEditedStateRegion(profile.locations[2] || stateRegion);
      setEditedPhoneNumber(profile.contactPhoneNumber || phoneNumber);
      setEditedCountryCode(profile.countryCode || countryCode);
      setEditedFirstName(profile.firstName || firstName);
      setEditedLastName(profile.lastName || lastName);
    }
  }, [
    profile,
    streetAddress,
    city,
    postalCode,
    stateRegion,
    phoneNumber,
    firstName,
    lastName,
  ]);

  const handleSaveChanges = () => {
    if (validateFields()) {
      dispatch(setStreetAddress(editedStreetAddress));
      dispatch(setCity(editedCity));
      dispatch(setPostalCode(editedPostalCode));
      dispatch(setStateRegion(editedStateRegion));
      dispatch(setPhoneNumber(editedPhoneNumber));
      dispatch(setCountryCode(editedCountryCode));
      dispatch(setFirstName(editedFirstName));
      dispatch(setLastName(editedLastName));
      dispatch(setContactInformationModal(false));
      dispatch(setFieldCompleted(true));
    }
  };

  const handleCancelEdit = () => {
    dispatch(setContactInformationModal(false));
  };

  const handleBackdropClick = (event: any) => {
    if (event.target === event.currentTarget) {
      handleCancelEdit();
    }
  };

  return (
    <div
      className={`fixed z-50 top-0 left-0 w-full h-full items-center justify-center bg-gray-500 bg-opacity-75  ${
        contactInformationModal ? "flex" : "hidden"
      }`}
      onClick={handleBackdropClick}
    >
      <div className={Classname.modalContent}>
        <div className={Classname.title}>Edit Contact Information</div>
        <label className="block">
          Street Address
          <input
            type="text"
            value={editedStreetAddress}
            onChange={(e) => setEditedStreetAddress(e.target.value)}
            className={Classname.input}
          />
          {errors.streetAddress && (
            <p className="text-red-500">{errors.streetAddress}</p>
          )}
        </label>
        <div className={Classname.flexRow}>
          <label className="block lg:w-1/2">
            City
            <input
              type="text"
              value={editedCity}
              onChange={(e) => setEditedCity(e.target.value)}
              className={Classname.input}
            />
            {errors.city && <p className="text-red-500">{errors.city}</p>}
          </label>
          <label className="block lg:w-1/2">
            Postal Code
            <input
              type="text"
              value={editedPostalCode}
              onChange={(e) => setEditedPostalCode(e.target.value)}
              className={Classname.input}
            />
            {errors.postalCode && (
              <p className="text-red-500">{errors.postalCode}</p>
            )}
          </label>
        </div>
        <label className="block mt-2">
          State/Region
          <input
            type="text"
            value={editedStateRegion}
            onChange={(e) => setEditedStateRegion(e.target.value)}
            className={Classname.input}
          />
          {errors.stateRegion && (
            <p className="text-red-500">{errors.stateRegion}</p>
          )}
        </label>
        <div className="block">
          <div className={Classname.mobileNumberTitle}>Mobile Number</div>
          <PhoneNumberInput
            value={editedPhoneNumber}
            onChange={(value) => setEditedPhoneNumber(value)}
          />
          {errors.phoneNumber && (
            <p className="text-red-500">{errors.phoneNumber}</p>
          )}
          <span className="text-sm mt-2 text-gray-400 leading-none">
            To contact you only in case of emergency, and this won't be public
            to travellers
          </span>
        </div>
        <div className="block">
          <div className={Classname.individualNamesTitle}>Individual Names</div>
          <div className={Classname.flexRow}>
            <label className="lg:w-1/2">
              First Name
              <input
                type="text"
                value={editedFirstName}
                onChange={(e) => setEditedFirstName(e.target.value)}
                className={Classname.input}
              />
              {errors.firstName && (
                <p className="text-red-500">{errors.firstName}</p>
              )}
            </label>
            <label className="lg:w-1/2">
              Last Name
              <input
                type="text"
                value={editedLastName}
                onChange={(e) => setEditedLastName(e.target.value)}
                className={Classname.input}
              />
              {errors.lastName && (
                <p className="text-red-500">{errors.lastName}</p>
              )}
            </label>
          </div>
        </div>
        <div className={Classname.justifyEnd}>
          <button onClick={handleCancelEdit} className={Classname.button}>
            Cancel
          </button>
          <button onClick={handleSaveChanges} className={Classname.saveButton}>
            Save changes
          </button>
        </div>
      </div>
    </div>
  );
}

export default ContactInformationModal;

const Classname = {
  modalContent:
    "bg-white p-6 mx-2 w-full max-w-[500px] rounded shadow-md max-h-[90vh] overflow-scroll",
  title: "font-bold mb-2",
  input: "w-full border border-gray-300 p-2 mt-2 rounded-md h-10",
  flexRow: "flex flex-col lg:flex-row justify-between gap-4 mt-2",
  button: "px-4 py-2 rounded-lg border-blue-500 border",
  saveButton: "ml-2 bg-blue-500 text-white px-4 py-2 rounded-lg",
  select: "border border-gray-300 p-2 mt-2 h-10",
  mobileNumberTitle: "font-bold mt-4 mb-4",
  individualNamesTitle: "font-bold mt-4",
  justifyEnd: "mt-4 flex justify-end",
};
